import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PageShell } from "@/components/PageShell";
import { usePageMeta } from "@/hooks/usePageMeta";

const ROLES = [
  { title: "Senior Paid Media Strategist", team: "Paid Media", location: "San Francisco / Remote", type: "Full-time" },
  { title: "Brand Designer", team: "Brand & Design", location: "Los Angeles", type: "Full-time" },
  { title: "SEO & Content Lead", team: "Organic Growth", location: "Remote (US)", type: "Full-time" },
];

export default function Careers() {
  usePageMeta(
    "Careers — Do the Best Work of Your Life | Build Right Partners",
    "Join Build Right Partners — a senior-only California marketing agency. Open roles in paid media, brand design, and SEO."
  );
  return (
    <PageShell testid="careers-page" overline="Careers" title="Do the best work" italic="of your life.">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-28">
        <p className="max-w-xl text-base font-light leading-relaxed text-slate-300 mb-14">
          Small team, senior bar, zero bureaucracy. If you want clients whose growth you can actually
          move — and partners who review your work, not your timesheet — talk to us.
        </p>
        <div className="border-t border-amber-500/15">
          {ROLES.map((r, i) => (
            <motion.a
              key={r.title}
              data-testid={`careers-role-${i + 1}`}
              href={`mailto:sales@buildrightpartners.net?subject=Application: ${encodeURIComponent(r.title)}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-amber-500/15 py-8 hover:bg-[#0A1128]/60 transition-colors duration-300 px-2 sm:px-4"
            >
              <div>
                <h2 className="font-serif text-2xl lg:text-3xl font-semibold text-amber-50 flex items-center gap-3">
                  {r.title}
                  <ArrowUpRight size={20} className="text-amber-400 opacity-0 -translate-x-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0" />
                </h2>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">
                  {r.team} · {r.location} · {r.type}
                </p>
              </div>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-300/80 border border-amber-400/30 rounded-full px-4 py-2 self-start sm:self-auto group-hover:bg-amber-400 group-hover:text-[#060B18] transition-colors duration-300">
                Apply by Email
              </span>
            </motion.a>
          ))}
        </div>
        <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">
          Don't see your role? Exceptional people should write anyway — sales@buildrightpartners.net
        </p>
      </section>
    </PageShell>
  );
}
